import styled from "styled-components";
import {TimelineElementAnimation } from "./Animations";
import { motion } from "framer-motion";

const Timeline = ({t}) => {
  return (
    <StyledWrapper className="wrapper">
      <div className="content">
        
        <StyledInfo>
        
          <div className="timeline">
            <motion.div
              variants={TimelineElementAnimation}
              initial="hidden"
              viewport={{ amount: "some", once: true }}
              whileInView="show"
              className="qloc  timeline-element"
            >
              <p>
                {t('timeline_qloc_p1')}
              </p>
              <p>
              {t('timeline_qloc_p2')}
              </p>
            </motion.div>

            <motion.div
              variants={TimelineElementAnimation}
              initial="hidden"
              viewport={{ amount: "some", once: true }}
              whileInView="show"
              className="ekolandia  timeline-element"
            >
              <p>
              {t('timeline_ekolandia_p1')}
              </p>
              <p>
              {t('timeline_ekolandia_p2')}
              </p>
            </motion.div>

            <motion.div
              variants={TimelineElementAnimation}
              initial="hidden"
              viewport={{ amount: "some", once: true }}
              whileInView="show"
              className="freelance  timeline-element"
            >
              <p>
              {t('timeline_freelance_p1')}
              </p>
              <p>
              {t('timeline_freelance_p2')}
              </p>
            </motion.div>
          </div>
        </StyledInfo>
      </div>
    </StyledWrapper>
  );
};

export default Timeline;


const StyledWrapper = styled.div`
  background-color: #483a37;
  position: relative;
  z-index: 2;
`;

const StyledInfo = styled.div`
  padding: 2rem;

  p {
    font-size: 1.75rem;
    position: relative;
    color: #f8f8f8;
    padding: 0 0 2rem 4rem;
  }

  .timeline > div {
    padding: 2rem 0rem 2rem 6rem;
  }

  .ekolandia {
    position: relative;
  }

  .ekolandia::after {
    content: "2021";
    position: absolute;
    left: -20px;
    height: 20px;
    width: 20px;
    left: 50px;
    top: 30px;
    font-size: 2rem;
    color: #e9e9e9;
  }
  .qloc {
    position: relative;
  }

  .qloc::after {
    content: "2021";
    position: absolute;
    left: -20px;
    height: 20px;
    width: 20px;
    left: 50px;
    top: 30px;
    font-size: 2rem;
    color: #e9e9e9;
  }

  .freelance {
    position: relative;
  }

  .freelance::after {
    content: "2022";
    position: absolute;
    left: -20px;
    height: 20px;
    width: 20px;
    left: 50px;
    top: 30px;
    font-size: 2rem;
    color: #e9e9e9;
  }

  .timeline > div::before {
    position: absolute;
    content: "";
    width: 40px;
    height: 40px;
    background: #e9e9e9;
    border-radius: 50%;
    left: -10px;
  }

  .timeline {
    position: relative;
  }
  .timeline::after {
    content: "";
    background: #e9e9e9;
    top: -20px;
    height: 100%;
    width: 5px;
    left: 7px;

    position: absolute;
  }
`;
